import React, { useState, useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";

const BrowserCompatBanner = () => {
  const [warning, setWarning] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || "";
    const isBrave = navigator.brave !== undefined;
    const isFirefox = ua.includes("Firefox");
    const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);
    const isOldSafari = /Safari/.test(ua) && !/Chrome/.test(ua) && /Version\/1[0-4]/.test(ua);

    const issues = [];

    if (isBrave) {
      issues.push("Brave's shields may block audio generation and AI features.");
    }
    if (isOldSafari) {
      issues.push("Older Safari versions may have issues with audio playback.");
    }
    if (isMobile && isFirefox) {
      issues.push("Firefox on mobile may have limited audio autoplay support.");
    }
    if (isMobile) {
      issues.push("Some audio features work best on desktop browsers.");
    }

    if (issues.length > 0) {
      const key = "lumifit_compat_dismissed";
      const prev = sessionStorage.getItem(key);
      if (!prev) {
        setWarning(issues[0]);
      }
    }
  }, []);

  if (!warning || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    sessionStorage.setItem("lumifit_compat_dismissed", "true");
  };

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-50 animate-in slide-in-from-bottom-4 duration-300"
      data-testid="browser-compat-banner"
    >
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 shadow-lg flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-amber-800">Browser Notice</p>
          <p className="text-xs text-amber-700 mt-1">{warning}</p>
        </div>
        <button
          onClick={dismiss}
          className="text-amber-400 hover:text-amber-600 flex-shrink-0"
          data-testid="dismiss-compat-btn"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default BrowserCompatBanner;
